import { batchActions } from './utils';
import { setData } from './data';
import { setStatus, unsetStatus } from './status';
import { LOADING, ERROR, selectNetworkListStatus, selectNetworkSearchStatus } from './selectors';
import { toJSON, PODCASTERS_SERVICE } from '../lib/Request';
import { Thunk, Network, Show } from '../types';

export const loadNetworkList = (): Thunk => async (dispatch, getState, { request }) => {
  const key = 'networkList';
  const endpoint = `${PODCASTERS_SERVICE}/v0/user/networks`;

  /* istanbul ignore next */
  if (selectNetworkListStatus(getState()) === LOADING) return;

  dispatch(setStatus({ [key]: LOADING }, 'audience/LOAD_NETWORK_LIST_REQUEST'));

  try {
    const { networks: data }: { networks: Pick<Network, 'id' | 'name'>[] } = await request
      .get(endpoint)
      .then(toJSON);

    dispatch(
      batchActions(
        [setData({ [key]: data }), unsetStatus([key])],
        'audience/LOAD_NETWORK_LIST_SUCCESS',
      ),
    );
  } catch (err) {
    switch (err.name) {
      case 'ResponseError':
      case 'TokenError': {
        dispatch(setStatus({ [key]: ERROR }, 'audience/LOAD_NETWORK_LIST_ERROR'));

        break;
      }

      /* istanbul ignore next */
      default:
        throw err;
    }
  }
};

export const searchNetworks = (filter: string): Thunk => async (
  dispatch,
  getState,
  { request },
) => {
  const key = 'networkSearchResults';
  const endpoint = `${PODCASTERS_SERVICE}/v0/user/showSearch?filter=${filter}`;

  /* istanbul ignore next */
  if (selectNetworkSearchStatus(getState()) === LOADING) return;

  dispatch(setStatus({ [key]: LOADING }, 'audience/LOAD_NETWORK_SEARCH_REQUEST'));

  try {
    const { shows: data }: { shows: Pick<Show, 'id' | 'name'>[] } = await request
      .get(endpoint)
      .then(toJSON);
    const dataWithFilter = { results: data, filter };

    dispatch(
      batchActions(
        [setData({ [key]: dataWithFilter }), unsetStatus([key])],
        'audience/LOAD_NETWORK_SEARCH_SUCCESS',
      ),
    );
  } catch (err) {
    switch (err.name) {
      case 'ResponseError':
      case 'TokenError': {
        dispatch(setStatus({ [key]: ERROR }, 'audience/LOAD_NETWORK_SEARCH_ERROR'));

        break;
      }

      /* istanbul ignore next */
      default:
        throw err;
    }
  }
};
